import { addDays } from 'date-fns/addDays'
import { isWithinInterval } from 'date-fns/isWithinInterval'
import { startOfDay } from 'date-fns/startOfDay'

import { useDynamicParams } from 'aem-libs-react-ts/src/hooks/useDynamicParams'

import type { EarlyRepaymentParams } from '../types'

export const usePaymentDisabledDateCheck = () => {
  const { possibleDaysToRepayment } = useDynamicParams<EarlyRepaymentParams>()

  const isPaymentDisabledDate = (date: Date): boolean => {
    const currentDate = startOfDay(new Date())
    const newDate = startOfDay(new Date(date))

    return !isWithinInterval(newDate, { start: currentDate, end: addDays(currentDate, possibleDaysToRepayment) })
  }

  return {
    isPaymentDisabledDate
  }
}
